<template>
  <el-dialog
      title="登录"
      :visible.sync="show"
      width="90%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
    <div class="review-login">
      <div class="review-login-content">
        <van-field v-model="mobile" type="tel" placeholder="请输入手机号" label="手机号" />
        <van-field
            v-model="code"
            center
            clearable
            label="短信验证码"
            placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button size="small" :loading="isloading" type="primary" @click="sendSms()" :disabled="!allowSend">{{isCount?count + 's':'发送验证码'}}</van-button>
          </template>
        </van-field>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button round size="small" type="primary" @click="mobileLogin()">登录</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {mobileCheck,mobileCode} from "../../api/Interface";
export default {
  name: "review-login",
  data(){
    return{
      show:false,
      mobile:'',
      code:'',
      count:60,
      isCount:false,
      allowSend:false,
      isloading:false,
      ischeckLoading:false,
      timer:null
    }
  },
  mounted(){

  },
  watch:{
    mobile(nval,oval){
      if(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(nval)){
        this.allowSend = true
      }else{
        this.allowSend = false
      }
    }
  },
  methods:{
    open(){
      this.show = true;
    },
    close(){
      this.show = false;
      this.mobile = '';
      this.code = '';
    },
    sendSms(){
      if(!this.allowSend) return;
      if(this.isCount) return;
      let params = {
        form_id:this.$route.query.id,
        mobile:this.mobile
      }
      this.isloading = true;
      mobileCode(params).then(res=>{
        this.isloading = false;
        if(res.state){
          this.$Message.success('发送成功');
          this.isCount = true;
          if(this.timer)clearInterval(this.timer);
          this.timer = setInterval(()=>{
            this.count --
            if(this.count<=0){
              clearInterval(this.timer);
              this.isCount = false;
              this.count = 60;
            }
          },1000)
        }
      })
    },
    mobileLogin(){
      if(this.ischeckLoading) return;
      if(!this.mobile){
        this.$Message.error('请填写手机号');
        return;
      }
      if(!this.code){
        this.$Message.error('请填写验证码');
        return;
      }
      let params = {
        form_id:this.$route.query.id,
        mobile:this.mobile,
        code:this.code
      }
      this.ischeckLoading = true;
      mobileCheck(params).then(res=>{
        this.ischeckLoading = false;
        if(res.state){
          this.$store.commit('updateReviewLogin', true)
          this.$store.commit('saveMobile', this.mobile)
          this.$store.commit('saveOpenid',this.mobile)
          this.$Message.success('登录成功');
          this.close();
          location.reload();
        }else{
          this.$Message.error(res.error);
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.review-login{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .review-login-content{

  }
}

/deep/ .el-dialog__body{
    padding:0!important;
}
/deep/ .van-field__label{
  width: 80px;
}
</style>